import { Route } from '@angular/router';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

import { onlineRestrictionGuard } from './guards/online-restriction.guard';

export const onlineGamesRoutes: Route[] = [
    {
        path: DC_ROUTING.ONLINE_GAMES,
        loadComponent: () => import('./pages/online-games/online-games.component').then((c) => c.OnlineGamesComponent),
    },
    {
        path: DC_ROUTING.GLOBAL_LOBBY,
        loadComponent: () => import('./pages/global-lobby/global-lobby.component').then((c) => c.GlobalLobbyComponent),
    },
    {
        path: DC_ROUTING.TEAMS_LOBBY,
        loadComponent: () => import('./pages/teams-lobby/teams-lobby.component').then((c) => c.TeamsLobbyComponent),
    },
    {
        path: DC_ROUTING.FRIENDS_LOBBY,
        canActivate: [onlineRestrictionGuard],
        loadComponent: () =>
            import('./pages/friends-lobby/friends-lobby.component').then((c) => c.FriendsLobbyComponent),
    },

    {
        path: 'online-gameplay-setup',
        loadComponent: () =>
            import('./pages/online-gameplay-setup/online-gameplay-setup.component').then(
                (c) => c.OnlineGameplaySetupComponent
            ),
    },
];
